import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PolicyData } from '../../interfaces/policy-data.model';

@Injectable({
  providedIn: 'root',
})
export class PolicyDataService {
  private baseApiUrl: string = environment.baseApiUrl;

  constructor(private _http: HttpClient) {}

  async premiumCalculation(policy: PolicyData): Promise<PolicyData> {
    try {
      const result = await firstValueFrom(
        this._http.post<PolicyData>(`${this.baseApiUrl}/policy/premiumCalculation`, policy),
      );
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createPolicyData(policy: PolicyData): Promise<PolicyData> {
    try {
      const result = await firstValueFrom(this._http.post<PolicyData>(`${this.baseApiUrl}/policy`, policy));
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getPolicyData(number: string): Promise<PolicyData> {
    try {
      const result = await firstValueFrom(this._http.get<PolicyData>(`${this.baseApiUrl}/policy/${number}`));
      return result;
    } catch (error) {
      throw error;
    }
  }

  async saveQuoteVariant(policy: PolicyData): Promise<{ quoteNumber: string }> {
    try {
      const result = await firstValueFrom(
        this._http.post<{ quoteNumber: string }>(`${this.baseApiUrl}/policy/saveQuote`, policy),
      );
      return result;
    } catch (error) {
      throw error;
    }
  }
}
